import { type ActionItem } from 'shared/ui'
import { truthy } from 'shared/lib'
import { type Campaign } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { campaignDetailsAction } from 'widgets/CampaignDetailsModal'
import { webhookAction } from 'widgets/EnrollByWebhook/actions/webhookAction/webhookAction.tsx'
import { editCampaign } from 'pages/campaigns/actions/actionItems/editCampaign'
import { duplicateCampaign } from 'pages/campaigns/actions/actionItems/duplicateCampaign'
import { deleteCampaign } from 'pages/campaigns/actions/actionItems/deleteCampaign'

export const getCampaignActions = (
  campaign: Campaign,
  onSuccessDelete: () => void,
  entities: IEntitiesStore
): ActionItem[] => {
  const editAction = editCampaign(campaign)
  const duplicateAction = duplicateCampaign(campaign, entities)
  const deleteAction = deleteCampaign(campaign, onSuccessDelete)
  const detailsAction = campaignDetailsAction(campaign)
  const campaignWebhookAction =
    campaign.webhook_url &&
    webhookAction({
      webhookUrl: campaign.webhook_url,
      source: 'campaign',
      sourceName: campaign.name,
    })

  if (
    campaign.status === 'active' ||
    campaign.status === 'disabled' ||
    campaign.status === 'draft'
  ) {
    return [editAction, detailsAction, campaignWebhookAction, duplicateAction, deleteAction].filter(
      truthy
    )
  }
  return []
}
